


export const getProgramPriceByDates = (allPrices, selectedDateByProgram) => {
    const _res = allPrices.filter(el => selectedDateByProgram.find((id) => el._id === id));
    let _totalPrice = 0;
    if(_res.length){
        _res.map(i => _totalPrice += i.standardPrice)
    }
    return _totalPrice > 0 ? `$${_totalPrice.toFixed(2)}` : 'Free';
}


export const getProductPriceFun = _list => {
    let _all_product_price = 0;
    if(_list.length){
        for (let i = 0; i < _list.length; i++) {
            _all_product_price = _all_product_price +  calculateTotalPriceForItem(_list[i].items);
        }
    }

    return _all_product_price;
}

export const calculateTotalPriceForItem  = _item => {
    let totallPrice = Number(_item.price) * Number(_item.count)
     if(_item?.subItems?.length > 0){
        totallPrice = _item.subItems.reduce( (tp, si) => (tp + (Number(si.price) * Number(si.count)) ), totallPrice);
     }
     return totallPrice

}

export const getProgramPriceByDates2 = (allPrices, selectedDateByProgram, numbderofCampers, _product_price) => {
    const _res = allPrices.filter(el => selectedDateByProgram.find((id) => el._id === id));
    let _totalPrice = 0;
    if(_res.length){
        _res.map(i => _totalPrice += i.standardPrice)
    }

    return _totalPrice ? ((_totalPrice * numbderofCampers) + getProductPriceFun(_product_price)).toFixed(2) : 'Free';
}

 


/**
 * The cost the API computed for one camper, picked by the experience they chose.
 *
 * `priceBreakdown` comes straight from `calcPriceCamperWise` — the function that decides the
 * amount actually charged — so quote and charge agree. `commuter` is null when the program
 * offers no day-only rate; such a camper falls back to the overnight figures.
 */
const experienceFor = (data, camper) => {
    const breakdown = data?.priceBreakdown;
    if (!breakdown) return null;
    return (camper?.isCommuter && breakdown.commuter) ? breakdown.commuter : breakdown.overnight;
}

/**
 * Cart line broken into its parts, summed over the campers on this program. Campers can differ
 * in experience within one program, so each is priced individually rather than multiplying.
 *
 * Returns null when the payload predates `priceBreakdown`, letting callers keep their old
 * arithmetic rather than rendering zeroes.
 */
export const getCartBreakdown = data => {
    if (!data?.priceBreakdown || !data?.campers?.length) return null;

    return data.campers.reduce((sum, camper) => {
        const e = experienceFor(data, camper);
        return {
            campRegistrationFee: sum.campRegistrationFee + (e.campRegistrationFee || 0),
            discountPrice: sum.discountPrice + (e.discountPrice || 0),
            taxPrice: sum.taxPrice + (e.taxPrice || 0),
            convenienceFee: sum.convenienceFee + (e.convenienceFee || 0),
            payable: sum.payable + (e.payable || 0),
        };
    }, { campRegistrationFee: 0, discountPrice: 0, taxPrice: 0, convenienceFee: 0, payable: 0 });
}

/**
 * What this cart line actually costs — the full per-camper charge including the non-refundable
 * fee, discount, tax and convenience fee.
 *
 * The fallback below is the pre-`priceBreakdown` arithmetic, kept so an older API response
 * still renders. It reads `commuterPrice` directly, which ignores the per-tier commuter
 * overrides and the discount, so it can differ from the charge — that is the bug this
 * function exists to route around, not behaviour to rely on.
 */
export  const getTotalAmount = data => {
    const breakdown = getCartBreakdown(data);
    if (breakdown) return breakdown.payable;

    // Nothing to price. Worth an explicit guard rather than letting the loops below throw:
    // there is no error boundary anywhere in this app, so one bad cart row blanks the page.
    if(!data?.campers?.length) return 0;

    if(data.byDates === 1){
        const _res = (data.additionalDates || []).filter(el => (data.selectedDates || []).find((id) => el._id === id));
        let _totalPrice = 0;

        for (let i = 0; i < data.campers.length; i++) {
            if(data.campers[i].isCommuter){
                for (let j = 0; j < _res.length; j++) {
                    _totalPrice = _totalPrice + _res[j].commuterPrice;
                }
            }else{
                for (let j = 0; j < _res.length; j++) {
                    _totalPrice = _totalPrice + _res[j].standardPrice;
                }
            }
        }
        return _totalPrice;

    }else{
        let _total_amount = 0;

        for (let i = 0; i < data.campers.length; i++) {
            if(data.registerNonRefundFee){
                _total_amount +=data.registerNonRefundFee
            }
            if(data.campers[i].isCommuter){
                _total_amount = _total_amount + data.commuterPrice
            }else{
                _total_amount = _total_amount + data.campRegistrationFee
            }
        }

        return _total_amount ? _total_amount : 0

    }
}

/**
 * Per-camper cost of one experience, for the "Overnight (…) / Day only (…)" choice.
 *
 * `fallback` is what to show when the API response predates `priceBreakdown`, and callers must
 * pass their own: `campRegistrationFee` does not mean the same thing on every endpoint — the
 * cart's copy excludes registerNonRefundFee while the booking list's includes it — so there is
 * no single expression that is correct everywhere.
 */
export const getExperiencePrice = (data, isCommuter, fallback = 0) => {
    const e = experienceFor(data, { isCommuter });
    return e ? e.payable : fallback;
}

/**
 * Per-camper price of one experience *before* the discount — the "Camp Registration Fee" line of
 * the breakdown, and by construction the same figure the program's card and detail page
 * advertise.
 *
 * This is what the "Overnight (…) / Day only (…)" chooser shows. The discount is deducted once,
 * visibly, in the Price detail panel and the payment total, rather than silently inside a radio
 * label that then disagrees with the page the parent just came from. The byDates half of that
 * same chooser has always summed `standardPrice`, which is likewise pre-discount, so this also
 * makes the two halves of one control agree.
 *
 * Use `getExperiencePrice` wherever the number has to be what is actually charged.
 */
export const getExperienceCampFee = (data, isCommuter, fallback = 0) => {
    const e = experienceFor(data, { isCommuter });
    return e ? e.campRegistrationFee : fallback;
}

/** Whether this program offers a day-only rate at all. */
export const hasCommuterOption = data =>
    data?.priceBreakdown
        ? Boolean(data.priceBreakdown.commuter)
        : (data?.commuterPrice || data?.earlyBirdCommuterPrice || data?.lateCommuterPrice || 0) > 0;

export   const getTotalAmount2 = (data, numberOfCampers )=> {
    if(data.byDates === 1){
        const _res = data.additionalDates.filter(el => data.selectedDates.find((id) => el._id === id));
        let _totalPrice = 0;

        for (let j = 0; j < _res.length; j++) {
            _totalPrice = _totalPrice + _res[j].standardPrice;
        }

        return _totalPrice ? _totalPrice * numberOfCampers : 0;

    }else{
        return data.campRegistrationFee;
    }
}
